import React from 'react'
import { formatDateTimeMEL } from "src/helpers/common_helpers";
interface PropData {
  colorsNew: any;
  tatStatusData: any;
  convertMinutes: any;
  jobSheetNumber?: string;
  vinNumber?: string;
  dealerName?: string;
}

const TatStatus = ({ colorsNew, tatStatusData, convertMinutes, jobSheetNumber, vinNumber, dealerName }: PropData) => {
  // Function to lighten a color
  const lightenColor = (color: string, percent: number) => {
    const num = parseInt(color.replace("#", ""), 16),
      amt = Math.round(2.55 * percent),
      R = (num >> 16) + amt,
      B = (num >> 8 & 0x00FF) + amt,
      G = (num & 0x0000FF) + amt;
    return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (B < 255 ? B < 1 ? 0 : B : 255) * 0x100 + (G < 255 ? G < 1 ? 0 : G : 255)).toString(16).slice(1);
  };

  const sortedTatStatusData = [...tatStatusData].filter((item: any) => item.tat > 0)
    .sort((a, b) => new Date(b.creationTime).getTime() - new Date(a.creationTime).getTime());

  return (
    <div className="p-2 my-0.5">
      <p className='text-center mb-3 text-bold' style={{ color: '#2c3e50', fontSize: '1.1rem', fontWeight: 600 }}>TAT Status</p>
      {(jobSheetNumber || dealerName) && (
        <div className="text-center mb-4" style={{ color: '#2c3e50', fontSize: '0.95rem', fontWeight: 500 }}>
          {jobSheetNumber && <div className="mb-1">Job Sheet No: <span className="text-primary">{jobSheetNumber}</span></div>}
          {dealerName && <div>Dealer Name: <span className="text-secondary">{dealerName}</span></div>}
          {vinNumber && <div>VIN Number: <span className="text-secondary">{vinNumber}</span></div>}
        </div>
      )}
      <div className="storage-legend mb-4 d-flex flex-wrap column-gap-3">
        {Object.keys(colorsNew).map((item) => (
          <div
            key={item}
            className="legend-item "
          >
            <span className="legend-dot w-2 h-2 rounded-full" style={{ background: colorsNew[item] }}></span>
            <span className="legend-label text-sm" style={{
              color: lightenColor(colorsNew[item], -20),
              fontWeight: 500,
              fontSize: "12px"
            }}>{item}</span>
          </div>
        ))}
      </div>
      <div className="storage-container d-flex py-4" style={{ overflowX: 'auto', overflowY: 'hidden', width: '100%' }}>
        <div style={{ flex: 1 }} />
        <div className="storage-cylinder-container" style={{ position: 'relative', width: '1600px', marginTop: '0px', flexShrink: 0 }}>
          {(() => {
            const displayData = [...sortedTatStatusData]
              .sort((a: any, b: any) => new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime())
              .reverse();

            const maxTat = Math.max(...(displayData.map((d: any) => d.tat || 0) || [1]));

            return displayData.map((data: any, index: number) => {
              const baseHeight = 320;
              const segmentMinHeight = 55;
              const segmentGap = 2; // Large gap to give cards vertical room

              const referenceMax = 3600; // 1 hour reference
              const scaledBaseHeight = baseHeight * Math.min(Math.max(maxTat, 60) / referenceMax, 1);
              const tatRatio = maxTat > 0 ? (data.tat || 0) / maxTat : 0.1;
              const finalHeight = Math.max(tatRatio * scaledBaseHeight, segmentMinHeight);

              const yPosition = displayData
                .slice(0, index)
                .reduce((sum: any, seg: any) => {
                  const segRatio = maxTat > 0 ? (seg.tat || 0) / maxTat : 0.1;
                  const segHeight = Math.max(segRatio * scaledBaseHeight, segmentMinHeight);
                  return sum + segHeight + segmentGap;
                }, 0);

              const cardColor = data.color || colorsNew[data.category] || colorsNew["Mel Tat"];
              const isLeft = index % 2 === 0;

              return (
                <div
                  key={index}
                  style={{
                    height: `${finalHeight}px`,
                    top: `${yPosition}px`,
                    left: '800px',
                    zIndex: displayData.length - index,
                    position: 'absolute',
                    width: '60px' // Strictly match cylinder width
                  }}
                  className="cylinder-segment-container"
                >
                  <div
                    className="cylinder-segment"
                    style={{ background: cardColor, height: '100%', position: 'relative', width: '60px' }}
                  >
                    {/* Elliptical top cap */}
                    <div
                      className="cylinder-cap cylinder-top-cap"
                      style={{
                        background: cardColor,
                        height: '30px',
                        width: '100%',
                        borderRadius: '50%',
                        position: 'absolute',
                        top: '-15px',
                        zIndex: 2,
                        border: `1px solid ${lightenColor(cardColor, -10)}`,
                        boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.3)'
                      }}
                    ></div>

                    <div className="title" style={{
                      position: 'absolute',
                      top: '50%',
                      right: isLeft ? '100%' : 'auto',
                      left: isLeft ? 'auto' : '100%',
                      marginRight: isLeft ? '16px' : '0',
                      marginLeft: isLeft ? '0' : '16px',
                      transform: 'translateY(-50%)',
                      padding: '4px 8px',
                      background: 'white',
                      borderRadius: '12px',
                      boxShadow: '0 6px 20px rgba(0,0,0,0.12)',
                      zIndex: 30,
                      width: 'max-content',
                      minWidth: '240px',
                      maxWidth: '400px',
                      border: `1.5px solid ${lightenColor(cardColor, 35)}`,
                      borderLeft: isLeft ? `1.5px solid ${lightenColor(cardColor, 35)}` : `6px solid ${cardColor}`,
                      borderRight: isLeft ? `6px solid ${cardColor}` : `1.5px solid ${lightenColor(cardColor, 35)}`,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '1px',
                    }}>
                      {/* TO SECTION */}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
                        <div style={{ lineHeight: '1.2' }}>
                          <span style={{ fontSize: '0.6rem', fontWeight: 800, color: '#aaa', textTransform: 'uppercase', marginRight: '4px' }}>To</span>
                          <span style={{ fontWeight: 700, color: cardColor, fontSize: '11px' }}>
                            {/* {data.pendingReason
                              ? data.pendingReason
                              : (data.to?.toLowerCase().includes('marked as pending') || data.to?.toLowerCase().includes('removed from pending'))
                                ? "Status Changed"
                                : data.to} */}
                            {data.to}
                          </span>
                        </div>
                        <span style={{ fontSize: '0.62rem', fontWeight: 500, color: '#666', lineHeight: '1.2' }}>
                          {formatDateTimeMEL(data.creationTimeEnd)}
                        </span>
                      </div>

                      {/* TAT + ARROW ROW */}
                      <div className="d-flex align-items-center" style={{ gap: '4px' }}>
                        <svg width="8" height="24" viewBox="0 0 14 52" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
                          <line x1="7" y1="50" x2="7" y2="14" stroke={cardColor} strokeWidth="2" strokeLinecap="round" />
                          <polygon points="7,2 1,14 13,14" fill={cardColor} />
                        </svg>
                        <div style={{ flex: 1, height: '1px', background: cardColor, opacity: 0.1 }} />
                        <span style={{
                          fontSize: '0.75rem',
                          fontWeight: 700,
                          color: cardColor,
                          padding: '2px 8px',
                          background: lightenColor(cardColor, 96),
                          borderRadius: '15px',
                          border: `1.2px solid ${lightenColor(cardColor, 40)}`,
                          whiteSpace: 'nowrap'
                        }}>
                          {convertMinutes(((data.tat ? data.tat : 0) + 1) / 60)}
                        </span>
                        <div style={{ flex: 1, height: '1px', background: cardColor, opacity: 0.1 }} />
                      </div>

                      {/* FROM SECTION */}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
                        <div style={{ lineHeight: '1.2' }}>
                          <span style={{ fontSize: '0.6rem', fontWeight: 800, color: '#aaa', textTransform: 'uppercase', marginRight: '4px' }}>From</span>
                          <span style={{ fontWeight: 600, color: '#444', fontSize: '11px' }}>
                            {/* {(data.from?.toLowerCase().includes('marked as pending') || data.from?.toLowerCase().includes('removed from pending'))
                              ? "Status Changed"
                              : data.from} */}
                            {data.from}
                          </span>
                        </div>
                        <span style={{ fontSize: '0.62rem', fontWeight: 500, color: '#888', lineHeight: '1.2' }}>
                          {formatDateTimeMEL(data.creationTime)}
                        </span>
                      </div>

                      {/* Pointer */}
                      <span
                        className={isLeft ? "bar-pointer-right" : "bar-pointer-left"}
                        style={{
                          borderRightColor: cardColor,
                          borderLeftColor: cardColor,
                          position: 'absolute',
                          top: '50%',
                          [isLeft ? 'right' : 'left']: '-16px',
                          transform: 'translateY(-50%)',
                          borderTop: '14px solid transparent',
                          borderBottom: '14px solid transparent',
                          [isLeft ? 'borderLeft' : 'borderRight']: `16px solid ${cardColor}`
                        }}
                      />
                    </div>

                    {/* Cylinder body */}
                    <div
                      className="cylinder-body"
                      style={{
                        background: `linear-gradient(90deg, ${lightenColor(cardColor, -12)} 0%, ${cardColor} 50%, ${lightenColor(cardColor, 18)} 100%)`,
                        height: '100%',
                        width: '100%',
                        position: 'relative',
                        zIndex: 1,
                        boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
                      }}
                    />

                    {/* Elliptical bottom cap */}
                    <div
                      className="cylinder-cap cylinder-bottom-cap"
                      style={{
                        background: cardColor,
                        height: '30px',
                        width: '100%',
                        borderRadius: '50%',
                        position: 'absolute',
                        bottom: '-15px',
                        zIndex: 0,
                        border: `1px solid ${lightenColor(cardColor, -10)}`,
                        boxShadow: '0 5px 15px rgba(0,0,0,0.2)'
                      }}
                    ></div>
                  </div>
                </div>
              );
            });
          })()}
          <div style={{
            height: `${(() => {
              const displayData = [...sortedTatStatusData]
                .sort((a: any, b: any) => new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime())
                .reverse();
              const maxTat = Math.max(...(displayData.map((d: any) => d.tat || 0) || [1]));
              return displayData.reduce((sum: any, seg: any) => {
                const baseHeight = 320;
                const segmentMinHeight = 55;
                const segmentGap = 2; // Must match render loop
                const referenceMax = 3600; // 1 hour reference
                const scaledBaseHeight = baseHeight * Math.min(Math.max(maxTat, 60) / referenceMax, 1);
                const segRatio = maxTat > 0 ? (seg.tat || 0) / maxTat : 0.1;
                const segHeight = Math.max(segRatio * scaledBaseHeight, segmentMinHeight);
                return sum + segHeight + segmentGap;
              }, 0) + 40;
            })()}px`
          }} className="relative">
          </div>
        </div>
        <div style={{ flex: 1 }} />
      </div>
    </div>
  )
}

export default TatStatus